import { render, staticRenderFns } from "./CustomerDataSummary.vue?vue&type=template&id=bb7e2ab4&scoped=true&"
import script from "./CustomerDataSummary.vue?vue&type=script&lang=js&"
export * from "./CustomerDataSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7e2ab4",
  null
  
)

export default component.exports